import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { setOpenNavBar } from '../../redux/actions/navbarAction'
import { PdfFocusProvider } from '../../components/pdf-viewer/pdfContext'
import ConversationLayout from './ConversationLayout'

/**
 * ChatScreen - Wrapper component for the new Claude-like conversation interface
 * Handles initialization and context setup
 */
const ChatScreen = () => {
  const { i18n } = useTranslation()
  const dispatch = useDispatch()
  const currentLang = i18n.language

  // Hide navbar when in chat screen
  useEffect(() => {
    dispatch(setOpenNavBar(false))
  }, [dispatch])

  return (
    <PdfFocusProvider>
      <ConversationLayout dir={currentLang === 'ar' ? 'rtl' : 'ltr'} />
    </PdfFocusProvider>
  )
}

export default ChatScreen